module.exports = __webpack_public_path__ + "static/media/img-07.5de00af2.png";